<template>
  <div style="display: grid; grid-template-rows: 1fr 1fr; width: 100%;">

      <!-- Ylärivi -->
    <div style="width: 100%; display: grid; grid-template-columns: 1fr;">


      <!-- No instance -->
      <k-chip v-if="!instance && !is_transcoder && !is_pull && channel" size="xs" color="transparent" icon="settings_ethernet">
        No instance
      </k-chip>

      <!-- Instance -->
      <k-menu offset-y :close-on-content-click="false" :nudge-width="150" full-width v-model="instance_menu" v-if="instance" :transition="false">

        <template #activator>
          <k-chip hovered :outlined="outlined" size="xs" v-if="instance" :color="instance_color" close icon style="width:100%; cursor: pointer;">
            <template #icon>
              <template v-if="get_system_info_field('ip')">
                <template v-if="is_transcoder && channel_type == 'output'">
                  <k-icon small>switch_video</k-icon>
                </template>
                <template v-else-if="is_transcoder && channel_type == 'input'">
                  <k-icon small type="symbols">desktop_cloud</k-icon>                  
                </template>
                <template v-else>
                  <k-icon small>settings_ethernet</k-icon>
                </template>
              </template>
              <template v-else>
                <k-progress-circular :value="20" :indeterminate="true" size="14"></k-progress-circular>&nbsp;
              </template>
            </template>

            <template #default>
              <span class="cut-text" style="flex: 1 1 auto;">
                {{instance_title}}
              </span>

            <!-- Cloudstreamer napit -->
              <div>
                <template v-if="is_cloudstreamer && instance && get_system_info_field('ip')">
                  <template v-if="!cloudstreamer_ready">
                    <k-progress-circular :value="20" :indeterminate="true" size="14"></k-progress-circular>&nbsp;
                  </template>
                  <template v-if="cloudstreamer_ready">
                    <k-icon size="xs" style="cursor: pointer;" @click.stop="open_gui">tune</k-icon>
                    <span style="padding-left: 5px; padding-right: 5px; cursor: pointer;" @click.stop="open_gui_mv">MV</span>
                  </template>
                </template>
              </div>
            </template>

            <template #close-icon>
              <template v-if="is_transcoder && ((channel_type == 'output') || (channel_type=='input'))">
                <k-icon small @click.stop="stop_transcoder">
                  <template v-if="instance_multiple_events">link_off</template>
                  <template v-else>cancel</template>
                </k-icon>
              </template>
              <template v-else>
                <span></span>
              </template>
            </template>
          </k-chip>
        </template>
        <template #default>
          <Instance v-model="instance_menu" :instance="instance" v-if="instance_menu && $is_admin()" />
        </template>
      </k-menu>

      <!-- Start instance (cloudstreamer/transcoder) -->
      <k-chip hovered :outlined="outlined" size="xs" v-if="!instance && is_transcoder && has_source_channel" color="transparent" @click.stop="start_transcoder" style="cursor: pointer !important;">

        <!-- Ikoni -->
        <template #icon>
          <template v-if="channel_type == 'output'">
            <k-icon small >play_circle_outline</k-icon>
          </template>
          <template v-if="channel_type == 'input'">
            <template v-if="transcoder_starting">
              <k-progress-circular :value="20" :indeterminate="true" size="14"></k-progress-circular>
            </template>
            <template v-else>
              <k-icon small>play_circle_outline</k-icon>
            </template>
          </template>
        </template>

        <!-- Teksti -->
        <template #default>
          <template v-if="channel_type == 'output'">
            Start Transcoder
          </template>
          <template v-if="channel_type == 'input'">
            <template v-if="transcoder_starting">
              UTX CORE Starting
            </template>
            <template v-else>
              Start UTX CORE
            </template>
          </template>
        </template>
      </k-chip>

      <!-- Pull Start / Stop -->
      <k-chip hovered :outlined="outlined" size="xs" v-if="!instance && is_pull && has_source_channel && !pull_status" color="transparent" @click.stop="start_pull" style="cursor: pointer !important;" icon="add_to_queue">
        Start Pull
      </k-chip>
      <template v-if="!instance && is_pull && has_source_channel && pull_status">
        <k-chip hovered :outlined="outlined" slot="activator" size="xs" color="success" close text-color="white" @click:close="stop_pull" icon="add_to_queue">
          <span>Pull Started</span>
        </k-chip>
      </template>
    </div>

    <!-- Alarivi CHANNEL-->
    <div style="display: grid; grid-template-columns: 1fr;" v-if="channel">
      <k-chip hovered :outlined="outlined" size="xs" :color="channel_color" @click.stop="open_channel" icon="movie" close close-icon="autorenew" @click:close="stop_router" style="cursor: pointer;">
        <span class="cut-text" style="flex: 1 1 auto;">
          <channel-title grid :channel="channel_data" :alternative="alternative" :input="input_title"/>
        </span>

        <div class="pr-1 pl-1" v-if="has_source_channel && output_type != 'none' && $is_admin()">
          <span style="font-weight: bold;" class="mh-1" v-if="output_override_time != -1" v-tooltip="'Output override time'">{{output_override_time}}</span> 
          <span style="font-weight: bold; text-transform: uppercase;" v-tooltip="output_type">{{output_type[0]}}</span> 
          <k-icon small style="vertical-align: middle;" v-if="output_state == 'active'" v-tooltip="'Output active'">sensors</k-icon>
          <k-icon small style="vertical-align: middle;" v-else-if="output_state == 'error'" v-tooltip="'Multiple active output detected!'">warning</k-icon>
          <k-icon small style="vertical-align: middle;" v-else>sensors_off</k-icon>
        </div>

        <div v-if="kepitstreamer_connection && kepitstreamer_connection != 'connected' && $is_admin()">
            <k-icon small style="vertical-align: middle;" v-tooltip="'Broadcaster -> Kepitstreamer: ' + kepitstreamer_connection" :color="get_color_for_state(kepitstreamer_connection)">warning</k-icon>
        </div>

     </k-chip>
    </div>

    <!-- MediaConnect napit -->
    <div>
      <k-chip :outlined="outlined" size="xs" v-if="instance && is_transcoder && is_mediaconnects && mediaconnects_status == 'standby' && $is_admin()" color="transparent" small @click.stop="start_mediaconnects" style="cursor: pointer !important;" icon="play_circle_outline">
        Start mediaconnects
      </k-chip>

      <k-chip :outlined="outlined" size="xs" v-if="is_transcoder && is_mediaconnects && mediaconnects_status != 'standby' && $is_admin()" :color="get_color_for_mediaconnects_state(mediaconnects_status)" :close="mediaconnects_status == 'active'" @click:close="stop_mediaconnects">
        Mediaconnects
      </k-chip>
    </div>
  </div>
</template>

<script>
import datelib from '@/lib/date.js'

import Instance from './Instance'
import EventModel from '@/models/event.js'
import ChannelModel from '@/models/channel.js'
import InstanceModel from '@/models/instance.js'
import ChannelTitle from '@/components/ChannelTitle.vue'

import _ from 'lodash'

export default {
	props: ["channel", "event", "type"],
	data () {
		return {
      outlined: true,
      instance_menu: false,
      timestamp: 0,
      updater: undefined,
      has_source_channel: undefined,
      is_current: undefined,
      start_transcoder_color: undefined,
      is_transcoder: undefined,
			is_mediaconnects: undefined,
      is_pull: undefined,
      is_admin_channel: undefined,
      is_cloudstreamer: undefined,
      pull_status: undefined,
      instance: undefined,
      instance_title: undefined,
      instance_color: undefined,
      channel_title: undefined,
      channel_color: undefined,
      channel_type: undefined,
			mediaconnects_status: undefined,
			disable_mediaconnects_button: false,
      kepitstreamer_connection: "",
      output_type: "none",
      output_state: "none",
      output_override_time: 0,
      cloudstreamer_ready: false,
      transcoder_starting: false,
      input_title: undefined,
      link_menu: false
		}
	},
  components: {
    Instance,
    ChannelTitle
  },
  mounted () {
    var self = this;
    this.timestamp = self.$store.state.timestamp;
    this.timestamp_update();

    this.updater = setInterval(function() {
      self.timestamp = self.$store.state.timestamp;
      self.timestamp_update();
    },1000);
  },
  beforeDestroy () {
    if (typeof(this.updater) != "undefined") {
      clearTimeout(this.updater);
    }
  },
	methods: {
    get_system_info_field(field) {
      return _.get(this.instance, ["system_info", field]);
    },
    is_updater () {
      return typeof(updater) != "undefined";
    },
    get_instance_color() {
      var instance = this.instance;
      var info = InstanceModel.status(instance);
      if (typeof(info) != "undefined") {
        return "success";
      }
      if (this.is_current == true) {
        return "danger";
      }
      return "";
    },
    get_start_transcoder_color() {
      if (this.is_current) return "danger";
      return "";
    },
    get_kepitstreamer_connection_status() {
      if(this.type == "destination") {
        var ch_input = ChannelModel.get_channel_input(this.channel, this.event);
        if(!_.isEmpty(ch_input) && _.get(ch_input, ["config", "type"]) == "tcp_pull") {
          var instance = this.instance;
          var info = InstanceModel.status(instance);
          return _.get(info, ["stats", "input_routers", _.get(ch_input, "key"), "destination", "state"], "disconnected");
        }
      }
      return undefined;
    },
    get_channel_color () {
      if(this.type == "destination") {
        var ch_input = ChannelModel.get_channel_input(this.channel, this.event);
        if(!_.isEmpty(ch_input) && _.get(ch_input, ["config", "type"]) == "tcp_pull") {
          var instance = this.instance;
          var info = InstanceModel.status(instance);
          return this.get_color_for_state(_.get(info, ["stats", "input_routers", _.get(ch_input, "key"), "source", "state"], "disconnected"));
        }
      }
      var ch = EventModel.input_channel(this.event);
      var alternative = EventModel.alternative(this.event);
      if (typeof(ch) != "undefined") {
        var info = ChannelModel.status(ch, alternative);
        if (typeof(info) != "undefined") {
          var data = info.instance;

          if (this.type == "source") {
            var color = this.get_color_for_state(data.source.state);
            if (typeof(color) != "undefined") return color;

          } else if (this.type == "destination") {
            var d  = _.find(data.destinations, (dest) => {
              return dest.events.includes(this.event.uuid);
            });

            if (typeof(d) != "undefined") {
              var color = this.get_color_for_state(d.status.state)
              if (typeof(color) != "undefined") return color;
            }
          }
        }
      }

      if (this.is_current == true) {
        return "danger";
      }

      return "";
    },
		get_mediaconnects_status () {
			var ch = this.channel
			if (typeof(ch) != "undefined") {
				var info = ChannelModel.mediaconnects_status(ch);
				if (typeof(info) != "undefined") {
					if(_.every(info, {status: "ACTIVE"})) {
						return "active"
					}
					if(_.every(info, {status: "STANDBY"})) {
						return "standby"
					}
					return "changing"
				}
			}
			return undefined
		},
    get_pull_status (channel) {
      var status = ChannelModel.status(channel);
      if (typeof(status) == "undefined") return false;
      return true;
    },
    update_output_state() {
      if(!this.has_source_channel) return;
      
      var ch = this.channel_data;
      var alternative = this.alternative;

      if (alternative == null || alternative == '') alternative = undefined;

      var outputs = _.reduce(ChannelModel.outputs_list(ch), (acc, output) => {
        if(output.type != "headend" || output.alternative != alternative) return acc;

        var active = _.get(output, "active", false);
        var override = _.find(_.get(ch, "meta.overrides", []), (override) => {
          return override.type == "config:output:"+output.type && override.subtype == "active" && (override.id == alternative || typeof(override.id) == 'undefined');
        });
        var override_active = _.get(override, "params.active", false);
        var override_time = _.get(override, "end_time", 0) - this.timestamp;


        var protocol = output.protocol;
        var protocol_override = _.find(_.get(ch, "meta.overrides", []), (override) => {
          return override.type == "config:output:"+output.type && override.subtype == "protocol" && (override.id == alternative || typeof(override.id) == 'undefined');
        });
        if (typeof(protocol_override) != "undefined" && protocol_override != null) {
          protocol = _.get(protocol_override, "params.protocol", protocol);
        }

        if(!_.isEmpty(_.get(output, "streamid"))) return acc


        return acc.concat([{
          type: output.type,
          active: active,
          override_active: override_active,
          override_time: override_time,
          protocol: protocol,
        }]);

      }, []);
      
      if(_.isEmpty(outputs)) {
        this.output_type = "none";
        this.output_state = "deactive";
        this.output_override_time = -1;
        return;
      }

      var active_outputs = _.filter(outputs, (output) => {
        return output.override_time > 0 ? output.override_active : output.active;
      });

      if(active_outputs.length > 1) {
        this.output_type = "multiple";
        this.output_state = "error";
        this.output_override_time = -1;
        return;
      }

      var override_deactive_output = _.find(outputs, (output) => {
        return output.override_time > 0 && !output.override_active;
      });
      if(active_outputs.length == 0 && _.isEmpty(override_deactive_output)) {
        this.output_type = "none";
        this.output_state = "deactive";
        this.output_override_time = -1;
        return;
      }

      var output = active_outputs[0] || override_deactive_output;
      
      this.output_type = output.protocol || output.type;
      this.output_state = (output.override_time > 0 ? output.override_active : output.active) ? "active" : "deactive";
      this.output_override_time = output.override_time > 0 ? datelib.format_duration(output.override_time, "hh:mm") : -1;
    },
    timestamp_update() {
      this.instance = ChannelModel.instance(this.channel, this.event);
      this.has_source_channel = EventModel.has_source_channel(this.event);
      this.is_current = EventModel.is_current(this.event, this.timestamp);
      this.start_transcoder_color = this.get_start_transcoder_color();
      this.is_transcoder = ChannelModel.is_transcoder(this.channel);
			this.is_mediaconnects = ChannelModel.is_mediaconnects(this.channel);
      this.instance_title = InstanceModel.title(this.instance);
      this.instance_color = this.get_instance_color();
      this.channel_color = this.get_channel_color();
      this.channel_type = ChannelModel.get_type(this.channel);
      this.is_admin_channel = ChannelModel.is_admin(this.channel);
			this.mediaconnects_status = this.get_mediaconnects_status();
      this.is_pull = ChannelModel.is_pull(this.channel);
      this.pull_status = this.get_pull_status(this.channel);
      this.kepitstreamer_connection = this.get_kepitstreamer_connection_status();
      this.instance_multiple_events = InstanceModel.events(this.instance).length > 1;
      this.is_cloudstreamer = (this.is_transcoder && this.channel_type == 'input');
      this.is_output_transcoder = (this.is_transcoder && this.channel_type == 'output');

      if (this.type == "destination") {
        this.input_title = _.get(this.event, ["system_meta","input"]);
      }

      if (this.is_cloudstreamer && this.instance && this.get_system_info_field("ip") && this.cloudstreamer_ready == false) {
        this.check_cloudstreamer();
      }

      this.update_output_state();
    },
    stop_pro () {
    },
    open_gui() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance));
      }
    },
    open_gui_mv() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open(InstanceModel.gui_url(this.instance) + "m/output0/mcr-view.html");
      }
    },
    open_streamdeck_url() {
      if (InstanceModel.gui_url(this.instance) != "") {
        window.open("streamdeck://plugins/message/fi.kepit.streamer-controller/url/" + InstanceModel.gui_url(this.instance));
      }      
    },
 		start_transcoder () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "output") {
        this.disable_mediaconnects_button = true;
        EventModel.start_transcoder(this.event, (msg) => {
          self.$message.success("Transcoder starting!");
          self.timestamp_update();
				  if(this.mediaconnects_status == "standby") {
            this.$nextTick(() => {
						  this.start_mediaconnects();
            })
				  }
        }, (err) => {
				  this.disable_mediaconnects_button = false;
          self.$message.success("Transcoder start failed!" + JSON.stringify(msg));
        });
      }
      if (ch.type == "input") {
        if (self.transcoder_starting == true) return;
        self.transcoder_starting = true;
                ChannelModel.start_transcoder(this.channel, (msg) => {
          self.$message.success("UTX CORE starting!");
          self.transcoder_starting = true;
          self.timestamp_update();
        }, (err) => {
          self.transcoder_starting = false;
          self.$message.success("UTX CORE start failed!" + JSON.stringify(msg));
        });
      }
    },
    check_cloudstreamer () {
      var self = this;
      if (this.instance && this.get_system_info_field("ip")) {
        var gui_url = InstanceModel.gui_url(this.instance);
        if (gui_url != "") {
          self.$http.get(gui_url + "static/test.html").then((response) => {
            self.cloudstreamer_ready = true;
            return;
          }).catch((err) => {
            console.log("Error response ",err);
          });
        }
      }
    },
    start_pull () {
      ChannelModel.port_request(this.channel, "", function(msg) {
        console.log(msg);
      }, function(msg) {
        console.log(msg);
      });
    },
    stop_pull () {
      ChannelModel.stop_channel(this.channel, "", function(msg) {
        console.log(msg);
      }, function(msg) {
        console.log(msg);
      });
    },
    mediamtx_start_pull () {
      var self = this;
      var channel = ChannelModel.get_channel(this.channel);
      InstanceModel.mediamtx_add_update_pull(null, channel.name, channel.meta.pull_url, function(msg) {
      }, function(msg) {
      });
    },
    mediamtx_stop_pull () {
      var self = this;
      if (typeof(self.pull_instance) == "undefined" || self.pull_instance == null) return;
      var channel = ChannelModel.get_channel(this.channel);
      if (typeof(channel) == "undefined" || channel == null) return;
      InstanceModel.mediamtx_remove_pull(self.pull_instance, channel.name, function(msg) {
      }, function(msg) {
      });
    },
		start_mediaconnects () {
			var self = this;
			EventModel.start_mediaconnects(this.event, (msg) => {
				self.$message.success("Mediaconnects started!");
				self.timestamp_update();
			}, (err) => {
				self.$message.success("Mediaconnects start failed!" + JSON.stringify(msg));
			});
		},
    stop_transcoder () {
      var self = this;
      var ch = ChannelModel.get_channel(this.channel);
      if (ch.type == "output") {

        var success_msg = "Transcoder stopped."
        var msg;
        if (this.instance_multiple_events) {
          msg = "Unlink event from transcoder?";
          success_msg = "Event unlinked from transcoder";
        }
        EventModel.stop_transcoder(this.event, (msg) => {
          self.$message.success(success_msg);
          self.timestamp_update();
          if (self.instance_multiple_events) {
            self.$emit("changed");
          }
        }, (err) => {
          self.$message.success("Transcoder stop failed!" + JSON.stringify(err));
        },msg);
      }
      if (ch.type == "input") {
        var instance = ChannelModel.instance(this.channel);
        this.cloudstreamer_ready = false;
        InstanceModel.stop_transcoder(instance, (msg) => {
          self.$message.success("UTX Core stopped");
          self.transcoder_starting = false;
          self.timestamp_update();
        }, (err) => {
          self.$message.success("UTX Core stop failed!" + JSON.stringify(err));
        });
      }
    },
		stop_mediaconnects () {
			var self = this;
			EventModel.stop_mediaconnects(this.event, (msg) => {
				self.$message.success("Mediaconnects stopped");
				self.timestamp_update();
			}, (err) => {
				self.$message.success("Mediaconnects stop failed!" + JSON.stringify(err));
			});
		},
    stop_router () {
    	if (this.type == "destination") this.stop_destination();
    	if (this.type == "source") this.stop_source();
    },
    stop_source () {
      var self = this;
      EventModel.router_stop_source(this.event, (msg) => {
        self.timestamp_update();
      }, (err) => {
      });
    },
    stop_destination () {
      EventModel.router_stop_destination(this.event, (msg) => {
        self.timestamp_update();
      }, (err) => {
      })
    },
    get_color_for_state (state) {
      if (state == "listening") return "warning";
      if (state == "disconnected") return "danger";
      if (state == "connecting") return "warning";
      if (state == "connected") return "success";
      return undefined;
    },
		get_color_for_mediaconnects_state(state) {
			if (state == "active") return "success";
			if (state == "standby") return "danger";
			if (state == "changing") return "warning";
			return undefined;
		},
    open_channel () {
      if (this.$is_admin()) {
        var ch = ChannelModel.get_channel(this.channel);
        if (typeof(ch) != "undefined") {
          this.$router.push("/dashboard/channel/" + ch.uuid );
        }
      }
    },
   	open_instance () {
      var instance = this.instance;
      if (typeof(instance) != "undefined") {
        this.open_instance_by_id(instance.id);
      }
    },
    open_instance_by_id (instance_id) {
      this.$router.push("/dashboard/instance/" + instance_id);
    }
	},
	computed: {
    channel_data () {
      return ChannelModel.get_channel(this.channel);
    },
    alternative () {
      var ch = this.channel_data;
      if (typeof(ch) != "undefined") {
        if (ch.type != "input") return;
        return EventModel.alternative(this.event);
      }
      return;
    }
	}
}
</script>
<style>

.dashboard_chip {
  width: 100% !important;
}

.margin {
	margin-top: 2px;
	margin-bottom: 2px;
}
.dashboard_link {
	cursor: pointer;
}
.gui_btn {
	font-size: 10px; height: 20px; min-width: 25px; width: 25px; max-width: 25px;
}
.channel-title {
/*word-break: break-all;
  white-space: normal;*/
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  }
.channel-title2 {

  text-align: left !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.cut-text { 
    display: inline-block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}

</style>
